import React, { useEffect } from 'react';
import AppBar from 'material-ui/AppBar/AppBar';
import Typography from 'material-ui/Typography/Typography';
import Toolbar from 'material-ui/Toolbar/Toolbar';

import PrimaryButton from '../../../view/common/component/PrimaryButton';
import LoadingState from '../../../view/common/LoadingState';
import EmptyState from '../../../view/common/EmptyState';
import NotificationSettingsList from '../../notificationSettings/components/NotificationSettingsList';
import useEmailSettings from './hooks/useEmailSettings';
import { getSearchParams } from '../../../state/reducer/analytics/analytics';

import Conf from '../../../api/config';
import Console from '../../../lib/debug';

const EmailSettingsView = () => {
    Console.render('EmailSettingsView');

    useEffect(() => {
        const navBar = document.getElementById('loading-nav-bar');
        navBar && navBar.classList.remove('loading-nav-bar');

        const sideNavBar = document.getElementById('loading-side-navbar');
        sideNavBar && sideNavBar.classList.remove('loading-side-navbar');

        const pageTooSmall = document.getElementById('page-too-small');
        pageTooSmall && pageTooSmall.remove();
    });

    const searchParams = getSearchParams();
    const { isLoading, notificationSettings, emailAddress } = useEmailSettings(
        searchParams.token
    );

    let body = null;

    if (isLoading) {
        body = <LoadingState />;
    }

    const onLogin = () => {
        let url = encodeURIComponent(window.location.href);
        window.location.replace(Conf.LOGIN + `?redirectUrl=${url}`);
    };

    const loginButton = <PrimaryButton onClick={onLogin}>Log In</PrimaryButton>;

    if (!isLoading) {
        body = (
            <div>
                <span className="secondary-copy">
                    Updating email settings for <strong>{emailAddress}</strong>.
                </span>
                <div className="notification-settings">
                    <NotificationSettingsList
                        settingsList={
                            notificationSettings.notificationSettingsList
                        }
                        token={searchParams.token}
                    />
                </div>
            </div>
        );
    }

    if (
        !isLoading &&
        notificationSettings.notificationSettingsList.length === 0
    ) {
        body = (
            <EmptyState title="Uh oh something went wrong">
                {loginButton}
            </EmptyState>
        );
    }

    return (
        <div className="email-settings-container">
            <AppBar position="fixed">
                <Toolbar>
                    <a href="https://www.trainheroic.com">
                        <img
                            src="https://static.trainheroic.com/images/trainheroic-gold-white.png"
                            height="20"
                            alt="TrainHeroic Logo"
                        />
                    </a>
                    <Typography
                        variant="title"
                        color="inherit"
                        className="flex"
                    />
                    <div className="right-container">{loginButton}</div>
                </Toolbar>
            </AppBar>
            <h1>Email Notification Settings</h1>
            {body}
        </div>
    );
};

export default EmailSettingsView;
